/**
 * aseo.ts — Categoría "Aseo y Limpieza" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_aseo",
  skuPrefix: "ASE",
  categoria: "Aseo y Limpieza",
} as const;

export const cat_aseo_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Jabón Líquido Rey 1000ml",
    marca: "Rey",
    origen: "Colombia",
    costo: 7800,
    precio: 12500,
    stock: 90,
    stockMinimo: 20,
    stockMaximo: 180,
    unidad: "botella",
    ubicacionFisica: "Estante A1",
    proveedor: "Jabonería Rey",
    vencimientoMeses: 36,
    pesoNeto: "1000ml",
    descripcionLarga:
      "Jabón líquido multiusos concentrado. Remueve grasa y suciedad en loza, pisos y superficies. Aroma limón refrescante.",
    especificaciones: [
      { clave: "Volumen", valor: "1000ml" },
      { clave: "Aroma", valor: "Limón" },
    ],
    imageKeywords: ["dish-soap", "cleaning-liquid", "soap-bottle"],
    color: "bg-yellow-400",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Detergente Ariel 2kg",
    marca: "Ariel",
    modelo: "Poder Total",
    origen: "Colombia",
    costo: 18500,
    precio: 28900,
    stock: 60,
    stockMinimo: 15,
    stockMaximo: 120,
    unidad: "bolsa",
    ubicacionFisica: "Estante A1",
    proveedor: "Procter & Gamble",
    vencimientoMeses: 24,
    pesoNeto: "2kg",
    descripcionLarga:
      "Detergente en polvo concentrado, fórmula Poder Total. Elimina manchas difíciles en una sola lavada. Rinde 40 lavadas.",
    especificaciones: [
      { clave: "Peso", valor: "2kg" },
      { clave: "Rendimiento", valor: "40 lavadas" },
    ],
    imageKeywords: ["detergent", "laundry-soap", "washing-powder"],
    color: "bg-blue-400",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Cloro Clorox 1L",
    marca: "Clorox",
    origen: "Colombia",
    costo: 4200,
    precio: 6900,
    stock: 120,
    stockMinimo: 25,
    stockMaximo: 220,
    unidad: "botella",
    ubicacionFisica: "Estante A2",
    proveedor: "The Clorox Company",
    vencimientoMeses: 12,
    pesoNeto: "1L",
    descripcionLarga:
      "Cloro blanqueador y desinfectante. Elimina 99.9% de bacterias, blanquea ropa y desinfecta superficies.",
    especificaciones: [
      { clave: "Volumen", valor: "1L" },
      { clave: "Concentración", valor: "5% hipoclorito" },
    ],
    imageKeywords: ["bleach", "clorox", "disinfectant"],
    color: "bg-white",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Papel Higiénico Familia x12",
    marca: "Familia",
    modelo: "Triple Hoja",
    origen: "Colombia",
    costo: 18000,
    precio: 27500,
    stock: 80,
    stockMinimo: 18,
    stockMaximo: 160,
    unidad: "paquete",
    ubicacionFisica: "Estante A3",
    proveedor: "Grupo Familia S.A.",
    descripcionLarga:
      "Papel higiúnico triple hoja, suave y resistente. Paquete económico con 12 rollos de 24m cada uno.",
    especificaciones: [
      { clave: "Rollos", valor: "12" },
      { clave: "Metros/rollo", valor: "24m" },
    ],
    imageKeywords: ["toilet-paper", "bathroom-tissue", "paper-rolls"],
    color: "bg-white",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Esponja Multiusos x3",
    marca: "Scotch-Brite",
    origen: "México",
    costo: 3500,
    precio: 5900,
    stock: 140,
    stockMinimo: 30,
    stockMaximo: 260,
    unidad: "paquete",
    ubicacionFisica: "Estante A2",
    proveedor: "3M Colombia",
    descripcionLarga:
      "Pack 3 esponjas dobles: fibra abrasiva para lo más difícil y espuma suave para loza delicada. No raya superficies.",
    especificaciones: [
      { clave: "Unidades", valor: "3" },
      { clave: "Tipo", valor: "Doble cara" },
    ],
    imageKeywords: ["sponge", "cleaning-sponge", "kitchen-sponge"],
    color: "bg-yellow-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Trapeador Microfibra",
    marca: "Vileda",
    modelo: "Ultramax",
    origen: "Alemania",
    costo: 22500,
    precio: 34900,
    stock: 35,
    stockMinimo: 8,
    stockMaximo: 70,
    unidad: "unidad",
    ubicacionFisica: "Estante A4",
    proveedor: "Vileda Colombia",
    tiempoEntrega: "5 días",
    garantia: "6 meses",
    material: "Microfibra",
    dimensiones: "40cm ancho",
    descripcionLarga:
      "Trapeador de microfibra plano con mango telescópico y base giratoria 360°. Ideal para pisos laminados y cerámica.",
    especificaciones: [
      { clave: "Material", valor: "Microfibra" },
      { clave: "Mango", valor: "Telescópico 1.2m" },
    ],
    imageKeywords: ["mop", "cleaning-mop", "floor-mop"],
    color: "bg-green-400",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Bolsas de Basura 80L x20",
    marca: "Estra",
    origen: "Colombia",
    costo: 6500,
    precio: 10500,
    stock: 95,
    stockMinimo: 20,
    stockMaximo: 180,
    unidad: "paquete",
    ubicacionFisica: "Estante A3",
    proveedor: "Estra S.A.",
    material: "Polietileno negro",
    descripcionLarga:
      "Bolsas de basura industriales 80L, calibre grueso, no se rasgan. 20 unidades por paquete.",
    especificaciones: [
      { clave: "Capacidad", valor: "80L" },
      { clave: "Unidades", valor: "20" },
    ],
    imageKeywords: ["garbage-bags", "trash-bags", "black-bags"],
    color: "bg-slate-800",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Shampoo Head & Shoulders 700ml",
    marca: "Head & Shoulders",
    modelo: "Menthol Fresh",
    origen: "México",
    costo: 15800,
    precio: 24500,
    stock: 70,
    stockMinimo: 15,
    stockMaximo: 140,
    unidad: "botella",
    ubicacionFisica: "Estante A5, cuidado personal",
    proveedor: "Procter & Gamble",
    vencimientoMeses: 36,
    pesoNeto: "700ml",
    descripcionLarga:
      "Shampoo anticaspa fórmula Menthol Fresh. Elimina caspa visible, deja cabello limpio y cuero cabelludo fresco.",
    especificaciones: [
      { clave: "Volumen", valor: "700ml" },
      { clave: "Tipo", valor: "Anticaspa" },
    ],
    imageKeywords: ["shampoo", "hair-care", "anti-dandruff"],
    color: "bg-blue-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Crema Dental Colgate 150g",
    marca: "Colgate",
    modelo: "Total 12",
    origen: "Colombia",
    costo: 5800,
    precio: 9500,
    stock: 110,
    stockMinimo: 25,
    stockMaximo: 220,
    unidad: "tubo",
    ubicacionFisica: "Estante A5, cuidado personal",
    proveedor: "Colgate-Palmolive",
    vencimientoMeses: 36,
    pesoNeto: "150g",
    descripcionLarga:
      "Crema dental de protección integral 12h contra caries, sarro, placa y mal aliento. Fórmula con flúor y antibacterial.",
    especificaciones: [
      { clave: "Peso", valor: "150g" },
      { clave: "Protección", valor: "12 horas" },
    ],
    imageKeywords: ["toothpaste", "colgate", "dental-care"],
    color: "bg-red-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Desinfectante Lysol 500ml",
    marca: "Lysol",
    modelo: "Spray Original",
    origen: "EE.UU.",
    costo: 14500,
    precio: 22500,
    stock: 65,
    stockMinimo: 15,
    stockMaximo: 130,
    unidad: "aerosol",
    ubicacionFisica: "Estante A2",
    proveedor: "Reckitt Benckiser",
    vencimientoMeses: 36,
    pesoNeto: "500ml",
    descripcionLarga:
      "Aerosol desinfectante que elimina 99.9% de virus y bacterias en superficies duras y suaves. Aroma original.",
    especificaciones: [
      { clave: "Volumen", valor: "500ml" },
      { clave: "Eficacia", valor: "99.9% virus/bacterias" },
    ],
    imageKeywords: ["disinfectant-spray", "lysol", "sanitizer-spray"],
    color: "bg-amber-500",
    shape: "square",
  }),
];
